export const ATTACHMENT_UPLOAD_CONFIG = {
    objectName: 'legal_document',
    attachmentName: 'legal-document-template-attachment',
    getPolicyUrl: '/legal_documents/attachments/policy',
    createPendingAttachmentIdUrl: '/legal_documents/attachments/pending_attachments',
    shouldBeRenamed: false,
};

export const MAX_FILE_SIZE = 5 * 1024 * 1024;

export const ACCEPTED_FORMATS = {
    'application/': ['.doc', '.docx', '.pdf'],
};

export enum UploadErrorCodes {
    fileTooLarge = 'file-too-large',
    invalidFileType = 'file-invalid-type',
    default = 'default',
}

export const UploadErrorCodesList = Object.values(UploadErrorCodes);
